(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.withdrawal-bank-account-us', ['pp.widgets-templates', 'pp.services.investor', 'pp.components.tooltip', 'pp.components.required-any', 'pp.values.form-lists']);

/**
 * @ngdoc directive
 * @name ppWithdrawalBankAccountUk
 * @description
 * Allows the user to register a bank account.
 *
 *
 * @restrict A
 */
ngModule.directive('ppWithdrawalBankAccountUs', [function () {
    return {
        restrict: 'A',
        templateUrl: 'widgets/_angular/withdrawal-bank-account-us/withdrawal-bank-account-us.tpl.html',
        scope: {
            account: '=ppWithdrawalBankAccountUs'
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: ['formLists', 'investorService', function (formLists, investorService) {
            var vm = this;

            //-- initial state

            vm.formLists = formLists;

            vm.usAccountNumberRegexp = investorService.usAccountNumberRegexp;
            vm.bicRegexp = investorService.bicRegexp;
            vm.abaRoutingCodeRegexp = investorService.abaRoutingCodeRegexp;
        }]
    };
}]);
})(window, window.angular);